import React from 'react'
import PropTypes from 'prop-types'

const FlagComponent = ({ countryCode }) => (
  <img
    className="flag-component"
    src={`/resources/um/graphics/flags/${countryCode.toLowerCase()}.gif`}
    alt="flag"
  />
)

FlagComponent.propTypes = {
  countryCode: PropTypes.string.isRequired,
}

export default FlagComponent
